import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrimAndSingleSpaceValueAccessorDirective } from './trimAndSingleSpace.directive';



@NgModule({
  declarations: [

    TrimAndSingleSpaceValueAccessorDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [

    TrimAndSingleSpaceValueAccessorDirective
  ]
})
export class TrimAndSingleSpaceModule { }
